var gigiMain = ( function( $ ) {
  'use strict';

  // declare global variables
  var
    // configMap = {
    //   logoImgUrlOutlined : '/wp-content/themes/office-untitled/images/gigi-logo-outline-white.png',
    //   logoImgUrlSolid : '/wp-content/themes/office-untitled/images/gigi-logo-solid-white.png'
    // },
    stateMap = {
      desktopSearchIsOpen : false,
      viewportWidth : 0,
      innerViewportHeight : 0,
      backToTopFadeInPosition : 0,
      scrollTargetPosition : 0,
      scrollTop : 0,
      deviceType : '',
      currentActiveImageNumber : 0,
      productSliderInitialized: false,
      productColorDotsRowWidth: 0,
      currentUrl : window.location.pathname + window.location.search + window.location.hash
    },
    calculateInnerViewportHeight,
    calculateViewportWidth,
    calculateBackToTopFadeInPosition,
    setMosaicRowHeight,
    calculateFeaturedRowHeight,
    scrollToSection,
    scrollToTop,
    initSlideShow,
    resetSlides,
    adjustProductColorDotsPerRow,
    initProductImageSlider,
    
    modifyExternalLinksTarget,
    hideSearch,
    toggleSearchVisibility,
    toggleDropdownMenu,
    hideDropdownMenu,
    showDropdownMenu,
    
    detectIfWrapped,
    manageContactForms,
    storeProductInquiry,
    sortColorSwatches,
    throttle,
    onScrollToTopClick,
    onSizeCartViewClick,
    onSearchButtonClick,
    onProductInquiryClick,
    onDropdownMenuItemClick,
    onDropdownMenuItemUnhover,
    onDropdownMenuItemHover,
    onScroll,
    onResize,
    injectCssIntoMcIframe,
    debounce,
    setUpBoutiquesPage,
    setUpColorsVipPage,

    vipSale = {
      config : {
        activePw : 'Password123'.toLowerCase(),
        saleIsEnabled : false,
        barIsEnabled : false,
        endDate : ''.trim(),
      },
      state : {
        storedPw : '',
      }
    },
    setUpVipCountdown,
    setUpVipSale,
    setupMenu,
    setUpAnnouncementBarStatusHandler,
    setUpEventHandlers,
    detectBrowserIe11,
    showOutdatedBrowserWarning,
    init;

  calculateInnerViewportHeight = function() {
    stateMap.innerViewportHeight = window.innerHeight;
  };

  

  calculateBackToTopFadeInPosition = function() {
    stateMap.backToTopFadeInPosition = window.innerHeight * 0.5;
  };


  // scroll to section function
  scrollToSection = function( hash, pixelOffset, duration, accessedViaUrlHash ) {
    // accessedViaUrlHash
    // check if hash exists on page


    stateMap.scrollTargetPosition = $( hash ).offset();
    

    $( 'html, body' ).animate( {
      // the non-style scrollTop property is provided by jQuery animate()
      scrollTop: stateMap.scrollTargetPosition.top - pixelOffset
    }, duration, function() {
      // Callback after animation
    });

  };


  scrollToTop = function( event ) {
    $( '.gigi-back-to-top-wrap' ).fadeOut();
    scrollToSection( '#top', 0, 1000, false );
  };



  onScrollToTopClick = function( event ) {
    scrollToTop( event );
    // disable default click behavior
    return false;
  };






  initProductImageSlider = function() {
    stateMap.productSliderInitialized = true;
    setTimeout( function() {
      $('.gigi-product-page__mobile-slider').slick({
        arrows: false,
        dots: true
      });
    }, 200);

  };


  adjustProductColorDotsPerRow = function() {
    $( '.product-single__color-list' ).css({ 'width' : '100%' });
    var rowWidth = $( '.product-single__color-list' ).outerWidth();
    var itemWidth = $( '.product-single__color-list-item' ).outerWidth() * 2;

    // make sure that there are always an even number of color dots.
    if( ( rowWidth / itemWidth ) % 1 !== 0 ) {
      rowWidth = Math.floor( rowWidth / itemWidth ) * itemWidth;
      $( '.product-single__color-list' ).css({ 'width' : rowWidth });
    }
  };

  manageContactForms = function() {

    $('.gigi-contact-form-wrap :input:enabled:visible:first').focus();
    
    // if ( stateMap.currentUrl.indexOf( 'contact_posted=true' ) > -1) {

    // }
          
    if ( $( 'body' ).hasClass( 'template-page--contact-form-product-inquiry' ) ) {

      if( sessionStorage.getItem( 'productInquiryAll' ) != null ) {

        $( '.gigi-contact-form__product-inquiry-info' ).show();
      
        // retrieving the product inquiry and set the radio button text and value on the product inquiry contact page
        var
          productInquiryAll = sessionStorage.getItem( 'productInquiryAll' ),
          productInquiryTitle = sessionStorage.getItem( 'productInquiryTitle' ),
          productInquiryUrl = sessionStorage.getItem( 'productInquiryUrl' );


        $( '[data-js="product-inquiry-val"]' ).val( productInquiryAll );

        $( '[data-js="product-inquiry-text"]' ).html( productInquiryTitle + '<br><a href="'+productInquiryUrl+'">'+productInquiryUrl+'</a>' );



        //console.log( 'session storage item accessed.' );
      
      } else {

        $( '.gigi-contact-form__product-inquiry-info' ).hide();

      }
    }


  };

  storeProductInquiry = function( event ) {

    event.preventDefault();
    var
      clickedUrl = event.currentTarget.href,
      productTitle = $( '.gigi-product-page__title' ).first().text(),
      productUrl = window.location.href,
      productAll = '\n'+productTitle +'\n'+productUrl,
      productInquiry = [
        [ 'productInquiryAll', productAll ],
        [ 'productInquiryTitle', productTitle ],
        [ 'productInquiryUrl', productUrl ]

      ];
    
    // creating new session storage with product specific info
    sessionStorage.clear();
    for ( var i = 0; i < productInquiry.length; i++ ) {
      sessionStorage.setItem( productInquiry[i][0], productInquiry[i][1]);
      if ( i === productInquiry.length-1 ) {
        window.location = clickedUrl; 
      }
    }
   
  };



  onScroll = function( event ) {
    
  };

  sortColorSwatches = function( event ) {
    
    if ( typeof colorSortOrder !== "undefined" ) {
      var
      count = 0,
      length = $( colorSortOrder ).length;

      $( colorSortOrder ).each( function( index, colorObject ){
      
      var $item = $( '.product-single__color-list-item[data-url-color-ref="'+colorObject.url_color_ref+'"]' );

      if ( $( '.product-single__color-list-item[data-url-color-ref="'+colorObject.url_color_ref+'"]' ).length  ) {
        count++;
        
        // $( $item).css({'order': count });
        $( $item ).detach().appendTo( '.product-single__color-list');
        
        $( $item ).attr( 'title', colorObject.color_name_1 );

        if (count % 2 == 0) {
         $( '.gigi-color-drop-icon', $item ).addClass( 'gigi-color-drop-icon--pointing-left');
        } else {
          $( '.gigi-color-drop-icon', $item ).addClass( 'gigi-color-drop-icon--pointing-right');
        }
      }
      //upon completion
      if ( index + 1  === length ) {
        $( '.product-single__color-list' ).animate( {'opacity': 1}, 400);
        $( '.product-single__colors-loader' ).hide();
      }
    



           // console.log( element.url_color_ref );
      });
    }
  };


  throttle = function(fn, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  };




// functions used:

  initSlideShow = function() {

    var
      timer,
      timerIsOn = false,
      $hoveredItem = {},
      lastImageNumber;

    function animateSlides() {

      // if there are any secondary images at all
      if ( $( '.gigi-product-mini-slides__product-image-wrap--secondary', $hoveredItem ).length > 0 ) {

        // if on 1 layer above the bottom layer or above
        if ( stateMap.currentActiveImageNumber <= lastImageNumber-1 ) {
          
          // make image in layer beneath visible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + ( stateMap.currentActiveImageNumber+1 ) + '"]', $hoveredItem ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );

          // make current layer invisible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + stateMap.currentActiveImageNumber + '"]', $hoveredItem ).addClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).removeClass( 'gigi-product-mini-slides__product-image-wrap--active' );

          //count++;
          stateMap.currentActiveImageNumber++;
          
        } else if ( stateMap.currentActiveImageNumber == lastImageNumber ) {
          
          // make primary image in top layer visible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + 0 + '"]', $hoveredItem ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );

          // make last layer invisible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + stateMap.currentActiveImageNumber + '"]', $hoveredItem ).addClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).removeClass( 'gigi-product-mini-slides__product-image-wrap--active' );
          
          //count = 0;
          stateMap.currentActiveImageNumber = 0;
        }


        timer = setTimeout( animateSlides, 2000 );

      }

    
    }

    function startSlideshow() {

      if ( !timerIsOn ) {
        timerIsOn = true;
        animateSlides();
      }
    }

    function stopSlideshow() {

      clearTimeout( timer );
      timerIsOn = false;
      //count = 0;
      stateMap.currentActiveImageNumber = 0;
      $( '.gigi-product-mini-slides__product-image-wrap', $hoveredItem ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' );

      $( '.gigi-product-mini-slides__product-image-wrap--primary', $hoveredItem ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );

    }


    // namespace the event in order to be able to turn the listener off on mobile
    $( '.gigi-product-mini-slides__product-images-wrap' ).on( 'mouseenter.gigi', '.gigi-product-mini-slides__product-images', function() {

        $hoveredItem = $( this );
        lastImageNumber = $( '.gigi-product-mini-slides__product-image-wrap', $hoveredItem ).last().attr( 'data-image-number' );

          startSlideshow();
        
        
    });

    // namespace the event in order to be able to turn the listener off on mobile
    $( '.gigi-product-mini-slides__product-images-wrap' ).on( 'mouseleave.gigi', '.gigi-product-mini-slides__product-images', function() {

        stopSlideshow();

    });


    function goToNextSlide( event ) {
      // for mobile swipe
      
      // turn off hover event listeners as they will be triggered on a clicked item after using the back button on mobile, which is not desired
      $( '.gigi-product-mini-slides__product-images-wrap' ).off( 'mouseenter.gigi mouseleave.gigi', '.gigi-product-mini-slides__product-images' );

      $hoveredItem = $( event.currentTarget );

      // if there are any secondary images at all
      if ( $( '.gigi-product-mini-slides__product-image-wrap--secondary', $hoveredItem ).length > 0 ) {

        
        lastImageNumber = parseInt( $( '.gigi-product-mini-slides__product-image-wrap', $hoveredItem ).last().attr( 'data-image-number' ), 10 );
        
        stateMap.currentActiveImageNumber =  parseInt( $( '.gigi-product-mini-slides__product-image-wrap--active', $hoveredItem ).attr( 'data-image-number' ), 10);


        // if on 1 layer above the bottom layer or above
        if ( stateMap.currentActiveImageNumber <= lastImageNumber-1 ) {
          
        
          // make image in layer beneath visible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + ( stateMap.currentActiveImageNumber + 1 ) + '"]', $hoveredItem ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );
          
          // make current layer invisible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + stateMap.currentActiveImageNumber + '"]', $hoveredItem ).addClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).removeClass( 'gigi-product-mini-slides__product-image-wrap--active' );
          
          stateMap.currentActiveImageNumber++;
          
          
        } else if ( stateMap.currentActiveImageNumber == lastImageNumber ) {
          
          // make primary image in top layer visible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + 0 + '"]', $hoveredItem ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );

          // make last layer invisible
          $( '.gigi-product-mini-slides__product-image-wrap[data-image-number="' + lastImageNumber + '"]', $hoveredItem ).addClass( 'gigi-product-mini-slides__product-image-wrap--hidden' ).removeClass( 'gigi-product-mini-slides__product-image-wrap--active' );
          
          stateMap.currentActiveImageNumber = 0;
        }

        

      } // end if .gigi-product-mini-slides__product-image-wrap--secondary

    } // end goToNextSlide function


    $( '.gigi-product-mini-slides__product-images-wrap' ).on( 'touchstart', '.gigi-product-mini-slides__product-images', goToNextSlide );

  };


  resetSlides = function(){
    //console.log( 'resetSlides triggered' );

    stateMap.currentActiveImageNumber = 0;
    // reset slides to show the primary image (all images) on mobile since the slideshow is by swipe not on hover and so will stop on last touched slide when no longer swiping
    $( '.gigi-product-mini-slides__product-image-wrap', 'body' ).removeClass( 'gigi-product-mini-slides__product-image-wrap--hidden' );
    $( '.gigi-product-mini-slides__product-image-wrap--primary', 'body' ).addClass( 'gigi-product-mini-slides__product-image-wrap--active' );

  };

  setMosaicRowHeight = function() {
    //console.log( 'setMosaicRowHeight' );
    if ( $( 'body' ).is( '[class*="template-page--multi-module"]' ) ) {
      
      $( '.gigi-multi-module-page-section__mosaic-block-row' ).each( function( index, element) {
        var mosaicRowWidth = $( element ).outerWidth( true );
        console.log( mosaicRowWidth );
        $( element ).css( { 'height' : (mosaicRowWidth / 3) + 'px' });
      });

    }
     
  };


  calculateFeaturedRowHeight = function() {
    if ( $( 'body' ).hasClass( 'template-index' ) ) {
      
      $( '.feature-row__text' ).each( function( index, element) {
        var featuredRowHeight = $( element ).outerHeight( true );
        //console.log( featuredRowHeight );
        $( element ).closest( '.gigi-featured-product-section-wrap' ).find( '.feature-row__image-wrapper' ).css( { 'height' : featuredRowHeight + 'px' });
      });

    }
     
  };

  modifyExternalLinksTarget = function() {
    // open links in new tab/window
    var links = document.links;
    for ( let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if ( links[i].hostname !== window.location.hostname ) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  };

  hideSearch = function() {
    $( 'body' ).css({ 'position': 'static' });
    stateMap.desktopSearchIsOpen = false;
    $( '.gigi-site-header-search-wrap' ).addClass( 'gigi-site-header-search-wrap--is-hidden' );
    $( '.aa-Panel' ).hide();
    
  };

  toggleSearchVisibility = function() {
    // page load starts with search being closed.
    stateMap.desktopSearchIsOpen = !stateMap.desktopSearchIsOpen;

    $( '.gigi-site-header-search-wrap' ).toggleClass( 'gigi-site-header-search-wrap--is-hidden' );


    
    
    if ( stateMap.desktopSearchIsOpen ) {
      

      $('.aa-Input').text('');
      $('.aa-Input').val( '');
      $('.aa-Input' ).focus();
      $( '.aa-Panel' ).show();

    } 
    else if ( !stateMap.desktopSearchIsOpen ) {
      $( 'body' ).css({ 'position': 'static' });
      $( '.aa-Panel' ).hide();
      
    }

  };

  toggleDropdownMenu = function( event ) {

    if ( stateMap.deviceType === 'mobile' || stateMap.deviceType === 'tablet' ) {
      // limit the click toggle to mobile only. The dropdowns should not toggled on desktop. 
      var $dropdown = $( '.site-nav__dropdown', event.currentTarget );
      var $button = $( '.site-nav__link--button', event.currentTarget );


      $( $dropdown ).toggleClass( 'gigi-site-header__menu-dropdown--is-hidden' );
      if ( $( $dropdown ).hasClass( 'gigi-site-header__menu-dropdown--is-hidden' ) ) {
        $ ( '.mobile-nav__icon--plus' , $button ).addClass( 'mobile-nav__icon--visible' );
        $ ( '.mobile-nav__icon--minus' , $button ).removeClass( 'mobile-nav__icon--visible' );
      } else {
        $ ( '.mobile-nav__icon--plus' , $button ).removeClass( 'mobile-nav__icon--visible' );
        $ ( '.mobile-nav__icon--minus' , $button ).addClass( 'mobile-nav__icon--visible' );
      }
    }

  };

  hideDropdownMenu = function( event ) {
    
    $( '.site-nav__dropdown' ).addClass( 'gigi-site-header__menu-dropdown--is-hidden' );
    
  };


  showDropdownMenu = function( event ) {
    
    $( '.site-nav__dropdown', event.currentTarget ).removeClass( 'gigi-site-header__menu-dropdown--is-hidden' );
    
  };

  detectIfWrapped = function( element ) {
    // var $element = $( element );
    // console.log( $( $element ).position().top );

    if ( $( element ).length && $( element ).position().top > 0 ) {
      // var $element = $( element );
     
      $( element ).addClass( 'is-wrapped' );
      // console.log( 'wrapped' );

    } else {
      $( element ).removeClass( 'is-wrapped' );
      // console.log( 'not wrapped' );
    }
   

  };

  calculateViewportWidth = function() {
    
    stateMap.viewportWidth = $( window ).width();
    if ( stateMap.viewportWidth >= 991 ) {
      $( 'body' ).addClass( 'gigi-desktop' ).removeClass( 'gigi-tablet' ).removeClass( 'gigi-mobile' );
      stateMap.deviceType = 'desktop';
    }

    if ( stateMap.viewportWidth < 991  && stateMap.viewportWidth > 768) {
      $( 'body' ).addClass( 'gigi-tablet' ).removeClass( 'gigi-desktop' ).removeClass( 'gigi-mobile' );
      stateMap.deviceType = 'tablet';
    }

    if ( stateMap.viewportWidth <= 768 ) {
      $( 'body' ).addClass( 'gigi-mobile' ).removeClass( 'gigi-desktop' ).removeClass( 'gigi-tablet' );
      stateMap.deviceType = 'mobile';
    }

  };

  onSizeCartViewClick = function( event ) {
    
  };

  // hide the open menu on mobile if search toggle is clicked.
  onSearchButtonClick = function() {
    $( '.gigi-site-header__main-nav-button--open' ).trigger( 'click' );
    toggleSearchVisibility();
  };

  onProductInquiryClick = function( event ) {
    storeProductInquiry( event );
  };

  onDropdownMenuItemClick = function( event ) {
    toggleDropdownMenu( event );
  };


  onDropdownMenuItemUnhover = function( event ) {
    hideDropdownMenu( event );
  };

  onDropdownMenuItemHover = function( event ) {
    showDropdownMenu( event );
  };

  onResize = function() {
    calculateViewportWidth();
    if ( stateMap.deviceType === 'mobile' && $( 'body').hasClass( 'template-product' ) && stateMap.productSliderInitialized === false ) {
      initProductImageSlider();
    }
    adjustProductColorDotsPerRow();
    setMosaicRowHeight();
    calculateFeaturedRowHeight();
    setupMenu();
    detectIfWrapped( '.gigi-size-chart-trigger-wrap' );

    var announcementBarHeight = ( $( '.announcement-bar-is-visible .announcement-bar--visible' ).outerHeight() || $( '.announcement-bar-is-visible .vip-announcement-bar--visible' ).outerHeight() ) ?? 0;

    var siteHeaderSearchHeight = $( '.announcement-bar-is-visible .gigi-site-header-search-wrap' ).outerHeight() ?? 0;
    //console.log( 'announcementBarHeight ' + announcementBarHeight );
    //console.log( 'siteHeaderSearchHeight ' + siteHeaderSearchHeight );
    //console.log( (announcementBarHeight + 66 + siteHeaderSearchHeight) + 'px' );
    
    $( '.gigi-site-header-search-wrap' ).css({
      'top' : (announcementBarHeight + 68) + 'px'
    });
    
    $( '.algolia-autocomplete' ).css({
      'padding-top' : (announcementBarHeight / 4) + 'px'
    });

     $( '.aa-Panel' ).css({
      'padding-top' : (announcementBarHeight / 4) + 'px'
    });

    $( '.page-container' ).css({ 
      'margin-top' : (announcementBarHeight + 68) + 'px'
    });

    $( '.cart-popup-wrapper' ).css({ 
      'top' : (announcementBarHeight + 68) + 'px'
    });

    $( '.mobile-nav-wrapper' ).css({ 
      'top' : (announcementBarHeight + 68) + 'px'
    });

  };

  injectCssIntoMcIframe = function() {
    setTimeout( function() {
      var
        iframeHead = $( '.mc-modal iframe').contents().find( 'head' ),
        iframeCss = '<!-- Gigi custom CSS injection with JS -->';

      if ( $( 'body' ).hasClass( 'gigi-fr-site' ) ) {
        iframeCss = '<!-- Gigi custom CSS injection with JS --><style type="text/css">input.button {border-radius: 0;  padding: 0 30px; height: 50px; line-height: 50px; font-weight: 500;} label, input, select, textarea { font-size: 16px;}.modalContent--mobile .modalContent__content { padding: 200px 22px 22px 22px; } .strictContent label {font-size: 0.8em;} </style>';
      } else {
        iframeCss = '<!-- Gigi custom CSS injection with JS --><style type="text/css">input.button {border-radius: 0; padding: 0 30px; height: 50px; line-height: 50px; font-weight: 500;} label, input, select, textarea { font-size: 16px;} .modalContent--mobile .modalContent__content { padding: 22px 22px 22px 22px; } .modalContent--mobile .modalContent__image { display: none;} .modalContent--mobile .content__titleDescription { margin-top: 15px;} .strictContent label {font-size: 0.8em; padding-bottom: 2px;} .field-wrapper { margin: 0 0 6px;} .email-field {margin: 0 0 24px;} </style>';
      }

      $( iframeHead ).append( iframeCss );

    }, 1000);
  };

  // debounce so filtering doesn't happen every millisecond
  debounce = function( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
  };

  setUpBoutiquesPage = function() {
    var $grid = $( '.isotope-grid' ).imagesLoaded( function() {
      
      // quick search regex
      var qsRegex;
      var filterValue;

      // use value of search field to filter
      var $quicksearch = $( '.gigi-quicksearch' ).keyup( debounce( function() {
        qsRegex = new RegExp( $quicksearch.val(), 'gi' );
        $grid.isotope();
        if ( $( '.gigi-quicksearch' ).val() === '' ) {
          $( '.gigi-quicksearch__reset' ).hide();
        }
        if ( $( '.gigi-quicksearch' ).val() !== '' ) {
          $( '.gigi-quicksearch__reset' ).show();
        }
        
        if ( !$grid.data('isotope').filteredItems.length ) {
          $('.no-items-message-wrap').fadeIn();
        } else {
          $('.no-items-message-wrap').hide();
        }

      }, 200 ) );

      // var isoData = $grid.data('isotope');
      console.log( 'setUpBoutiquesPage');
      $grid.isotope({
        itemSelector: '.isotope-grid__item',
        layoutMode: 'fitRows',
        getSortData: {
          country: '[data-country]',
          region: '[data-region]',
          city: '[data-city]',
          store_name: '[data-store-name]'
        },
        // sort by country then region then city then store name
        sortBy: [ 'country', 'region', 'city', 'store_name' ],
        filter: function() {
          var $this = $(this);
          var storeDetails = $this.find('.gigi-boutiques-page-section__item-city').text();
          storeDetails += ' ' + $this.find('.gigi-boutiques-page-section__item-region').text();
          storeDetails += ' ' + $this.find('.gigi-boutiques-page-section__item-country').text();
          var searchResult = qsRegex ? storeDetails.match( qsRegex ) : true;
          var buttonResult = filterValue ? $this.is( filterValue ) : true;
          return searchResult && buttonResult;
          //return qsRegex ? $(this).find('.gigi-boutiques-page-section__item-city').text().match( qsRegex ) : true;
        }
        
      }).css({ 'opacity' : '1' });



      $( '.gigi-quicksearch' ).on( 'click', function() {
        $( this ).attr( 'placeholder','');

      });

      $( '.gigi-quicksearch__reset' ).on( 'click', function() {
        $( '.gigi-quicksearch' ).val( [] ).trigger( 'keyup' );
      });

      var placeHolder = $( '.gigi-quicksearch' ).attr( 'data-quicksearch-placeholder' );
      $( '.gigi-quicksearch' ).on( 'blur', function() {

        $( this ).attr( 'placeholder', placeHolder );
      });

      

    });

    

  };

  setUpColorsVipPage = function() {
    // if (location.search.length) {
    //   for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    //     aKeyValue = aCouples[i].split('=');
    //     if (aKeyValue.length > 1) {
    //       Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    //     }
    //   }
    // }
    // creating new sessionstorage with product specific info
    
    
    // console.log( typeof(location.href));
    var urlArray = location.pathname.substr(0).split('/');
    // console.log( currentTags[currentTags.length - 1] );
    var urlParameters = urlArray[urlArray.length - 1].split('?');
    
    var tagsArray = urlParameters[0].split('+');
    var tagPrimary = tagsArray[0]; // 'primary'
    var tagColor = tagsArray[1];
    var colorNameActive = '';
    var tagType = sessionStorage.getItem('type') ? sessionStorage.getItem('type') : '*';
    var tagTypeName = sessionStorage.getItem('typeName') ? sessionStorage.getItem('typeName') : $('.gigi-colors-section__type-list-item-wrap').first().find( '.gigi-colors-section__type-list-item' ).text();

    // vip page
    var vipTagType = '*';
    var vipTagTypeName = $('.gigi-vip-section__type-list-item-wrap').first().find( '.gigi-vip-section__type-list-item' ).text();
    // $( '.debug' ).append( 'tagPrimary: ' + tagPrimary + '<br>');
    // $( '.debug' ).append( 'tagColor: ' + tagColor + '<br>');
    // $( '.debug' ).append( 'tagType: ' + tagType + '<br>');

    $( '.gigi-colors-section .product-single__color-list-item[data-color-handle="'+ tagColor +'"]' ).addClass( 'product-single__color-list-item--active' );

    $( '.gigi-colors-section .product-single__color-box[data-color-handle="'+ tagColor +'"]' ).addClass( 'product-single__color-box--active' );
    $( '.gigi-colors-section .product-single__color-swatch[data-color-handle="'+ tagColor +'"]' ).addClass( 'product-single__color-swatch--active' );

    // colors page
    $( '.gigi-colors-section__type-list-item-wrap[data-filter="'+ tagType +'"]' ).addClass( 'gigi-colors-section__type-list-item-wrap--active' );

    // vip page
    $( '.gigi-vip-section__type-list-item-wrap[data-filter="'+ vipTagType +'"]' ).addClass( 'gigi-vip-section__type-list-item-wrap--active' );

    colorNameActive = $( '.gigi-colors-section .product-single__color-list-item--active' ).attr( 'data-color-name' );
    
    //colors page
    $( '.template-collection--colors .gigi-colors-section__title' ).text( tagTypeName + ' ' + colorNameActive );

    // vip page
    $( '.template-collection--vip .gigi-vip-section__title' ).text( vipTagTypeName );

   

    var currentCollectionHandle  = $( '.gigi-colors-section__slider' ).attr( 'data-current-collection-handle' );
    var initialSlideId = $( '.gigi-colors-section__slide--single[data-collection-handle="'+currentCollectionHandle+'"]' ).attr( 'data-slide-id' );

    $('.gigi-colors-section .slider-single').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      //arrows: true,
      fade: true,
      //adaptiveHeight: true,
      //infinite: false,
      infinite: true,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
      initialSlide: initialSlideId,
      asNavFor: '.slider-nav',
      dots: true
     });

      

    
    $('.gigi-colors-section .slider-nav')
      .on('init', function(event, slick) {


        $( '.gigi-colors-section__slider-wrap').removeClass( 'gigi-colors-section__slider-wrap--hidden' );
      })
      .slick({
        asNavFor: '.slider-single',
        centerMode: true,
        //initialSlide: initialSlideId,
        slidesToShow: 5,
        // slidesToScroll: 5,
        // dots: true,
        focusOnSelect: true,
        // infinite: false,
        // responsive: [{
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 5,
        //     slidesToScroll: 0,
        //   }
        // }, {
        //   breakpoint: 640,
        //   settings: {
        //     slidesToShow: 4,
        //     slidesToScroll: 4,
        //   }
        // }, {
        //   breakpoint: 420,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        // }
        // }]
    });



    
    $( '.gigi-colors-section__slide--nav-item-wrap[data-collection-handle="'+currentCollectionHandle+'"]' ).trigger( 'click' );


    var $parentWrap,
        colorName,
        colorNameActive,
        colorCatName;


    $parentWrap = $( '.gigi-colors-section .product-single__color-list-item--active' ).closest('.gigi-colors-section__color-list-wrap' ).addClass( 'gigi-colors-section__color-list-wrap--active' );
    
    colorNameActive = $( '.gigi-colors-section .product-single__color-list-item--active' ).attr( 'data-color-name' );
    colorCatName = $( '.gigi-colors-section__color-list-item-name', $parentWrap ).attr( 'data-color-cat-name' );
    $( '.gigi-colors-section__color-list-item-name', $parentWrap ).text( colorNameActive );


    $('.gigi-colors-section .product-single__color-list-item').on( 'mouseenter.gigi', function(event ){
      $parentWrap = $( event.currentTarget ).closest('.gigi-colors-section__color-list-wrap' );
      colorName = $( event.currentTarget ).attr( 'data-color-name' );
      colorCatName = $( '.gigi-colors-section__color-list-item-name', $parentWrap ).attr( 'data-color-cat-name' );
      $( '.gigi-colors-section__color-list-item-name', $parentWrap ).text( colorName );

    }).on( 'mouseleave.gigi', function(event ){
      if ( $( $parentWrap ).hasClass( 'gigi-colors-section__color-list-wrap--active' ) ) {

        $( '.gigi-colors-section__color-list-item-name', $parentWrap ).text( colorNameActive );

      } else {
        $( '.gigi-colors-section__color-list-item-name', $parentWrap ).text( colorCatName );
      }

    });

    var
      locationPathname,
      collectionHandle = urlArray[2];
    $( '.gigi-colors-section .product-single__color-list-item').on( 'click', function(event){
      event.preventDefault();
      // prevent the mousing over behavior once a selection is made

      tagColor = $( event.currentTarget ).attr( 'data-color-handle' );

      collectionHandle = $( event.currentTarget ).closest( '.slick-slide' ).attr( 'data-collection-handle' );


      location.pathname = '/collections/' + collectionHandle + '/primary+' + tagColor;

      // $( '.debug' ).append( 'locationPathname: ' + locationPathname + '<br>');
    });

    //init Isotope
    // layout Isotope after each image loads
    var $grid = $( '.isotope-grid' ).imagesLoaded( function() {
      
      // var isoData = $grid.data('isotope');

      if ( $( 'body' ).hasClass( '.template-collection--colors' ) ) {
        $grid.isotope({
          itemSelector: '.isotope-grid__item',
          layoutMode: 'fitRows',
          filter: tagType
        });
      }

      if ( $( 'body' ).hasClass( '.template-collection--vip' ) ) {
        $grid.isotope({
          itemSelector: '.isotope-grid__item',
          layoutMode: 'fitRows',
          filter: vipTagType
        });
      }


    });

    $grid.on( 'layoutComplete', function( event, laidOutItems ) {
      // var numItems = isoData.filteredItems.length;
      

      if ( laidOutItems.length === 0 ) {
        setTimeout( function(){
          $grid.isotope({
            filter: '*'
          });

          tagType = '*';

          vipTagType = '*';
          
          //colors page
          $( '.gigi-colors-section__type-list-item-wrap[data-filter="'+ tagType +'"]' ).addClass( 'gigi-colors-section__type-list-item-wrap--active' );

          //vip page
          $( '.gigi-vip-section__type-list-item-wrap[data-filter="'+ vipTagType +'"]' ).addClass( 'gigi-vip-section__type-list-item-wrap--active' );

        }, 200 );
      }
    });

    // colors page
    $('.gigi-colors-section__type-list-item-wrap').on( 'click', function(event){
      $('.gigi-colors-section__type-list-item-wrap').removeClass( 'gigi-colors-section__type-list-item-wrap--active' );
      $( event.currentTarget ).addClass( 'gigi-colors-section__type-list-item-wrap--active' );
      tagType = $( event.currentTarget ).attr( 'data-filter' );
      sessionStorage.setItem('type', tagType);
      tagTypeName = $( event.currentTarget ).text();
      sessionStorage.setItem('typeName', tagTypeName );

      $( '.template-collection--colors .gigi-colors-section__title' ).text( tagTypeName + ' ' + colorNameActive );
    
      
      var filterValue = tagType;
      $grid.isotope({ filter: filterValue });
      if ( !$grid.data('isotope').filteredItems.length ) {
        $('.no-items-message-wrap').fadeIn();
      } else {
        $('.no-items-message-wrap').hide();
      }
    });

    // vip page
    $('.gigi-vip-section__type-list-item-wrap').on( 'click', function(event){
      
      $('.gigi-vip-section__type-list-item-wrap').removeClass( 'gigi-vip-section__type-list-item-wrap--active' );
      $( event.currentTarget ).addClass( 'gigi-vip-section__type-list-item-wrap--active' );
      vipTagType = $( event.currentTarget ).attr( 'data-filter' );
      // sessionStorage.setItem('vipType', vipTagType);
      vipTagTypeName = $( event.currentTarget ).text();
      // sessionStorage.setItem('vipTypeName', vipTagTypeName );

      $( '.template-collection--vip .gigi-vip-section__title' ).text( vipTagTypeName );
    
      
      var filterValue = vipTagType;
      $grid.isotope({ filter: filterValue });
      

      // if ( !$grid.data('isotope').filteredItems.length ) {
      //   $('.no-items-message-wrap').fadeIn();
      // } else {
      //   $('.no-items-message-wrap').hide();
      // }
    });

    // vip page
    $( '.gigi-vip-section__type-list-item-wrap[data-filter="*"]' ).trigger( 'click' );

    var dataTypeFilter;

    // colors page
    $( '.gigi-colors-section__type-list-item-wrap' ).each( function( index, element ){
      dataTypeFilter = $( element ).attr( 'data-filter' );
      //console.log( dataTypeFilter );
      if ( dataTypeFilter !== '*' ) {

        //console.log( $( dataTypeFilter, '.isotope-grid' ) );
        if( $( dataTypeFilter, $('.isotope-grid') ).length > 0 ) {
          $( element ).show();
        } else {
          $( element ).hide();
        }

      }
    });

    // vip page
    $( '.gigi-vip-section__type-list-item-wrap' ).each( function( index, element ){
      dataTypeFilter = $( element ).attr( 'data-filter' );
      //console.log( dataTypeFilter );
      if ( dataTypeFilter !== '*' ) {

        //console.log( $( dataTypeFilter, '.isotope-grid' ) );
        if( $( dataTypeFilter, $('.isotope-grid') ).length > 0 ) {
          $( element ).show();
        } else {
          $( element ).hide();
        }

      }
    });





  };


  
  // vipSale.init = function() {
  //   console.log( vipSale.config.activePw );
  //   console.log( vipSale.config.saleIsEnabled );
  //   console.log( vipSale.config.barIsEnabled );
  //   console.log( vipSale.state.storedPw );

  //   if ( !vipSale.config.saleIsEnabled ) {
  //     vipSale.deleteStoredPw( 'vip_pw' );
  //   }

  //   if ( vipSale.getStoredPw( 'vip_pw' ) != null ) {
  //     vipSale.state.storedPw = vipSale.getStoredPw( 'vip_pw' );
  //   }

  //   if ( vipSale.state.storedPw && vipSale.config.activePw && vipSale.state.storedPw === vipSale.config.activePw ) {



  //   } else {

  //   }


  // };

  vipSale.hideFromAlgoliaSearchResults = debounce(function() {
    // externally called from algolia_autocomplete.js.liquid
    $( '.gigi-aa-suggestion__product' ).each( function( index, element) {
      if ( $( element ).text().indexOf( 'vip-trunk' ) >-1 ) {
        $( element ).closest( '.aa-suggestion').hide();
      }

    });
    
    //console.log( 'vips hidden' );

  }, 300);

  // vipSale.deleteStoredPw = function( key ) {
  //   localStorage.removeItem( key );
  // };

  // vipSale.getStoredPw = function( key ) {
  //   localStorage.getItem( key )
  // };

  // vipSale.hideVipBar = function() {

  // };

  // vipSale.showVipBar = function() {

  // };

  // vipSale.hideRegularBar = function() {

  // };

  // vipSale.showRegularBar = function() {

  // };

  setUpVipCountdown = function() {

    // Eastern time: GMT-05:00
    let
      configDate = vipSale.config.endDate ? vipSale.config.endDate + 'T23:59:59-05:00' : '',
      countDownDate = new Date( configDate ).getTime(),
      now,
      distance,
      days,
      hours,
      minutes,
      seconds,
      daysText,
      hoursText,
      minutesText,
      countDownNode = document.querySelector( '.gigi-vip-section__countdown' ),
      timeNode = document.querySelector( '.gigi-vip-section__countdown-time' ),
      daysNode = timeNode && timeNode.querySelector( '.gigi-vip-section__countdown-time-number--days'),
      hoursNode = timeNode && timeNode.querySelector( '.gigi-vip-section__countdown-time-number--hours'),
      minutesNode = timeNode && timeNode.querySelector( '.gigi-vip-section__countdown-time-number--minutes'),
      secondsNode = timeNode && timeNode.querySelector( '.gigi-vip-section__countdown-time-number--seconds');
    
    
    
    console.log( countDownNode );
    if ( vipSale.config.saleIsEnabled && configDate && countDownDate && countDownNode ) {

      countDownNode.style.display = 'block';

      // Update the countdown every 1 second
      let x = setInterval( function() {

        // Get today's date and time
        now = new Date().getTime();
        // Find the distance between now and the countdown date
        distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        days = Math.floor( distance / ( 1000 * 60 * 60 * 24 ));
        hours = Math.floor(( distance % ( 1000 * 60 * 60 * 24 )) / ( 1000 * 60 * 60 )) ;
        minutes = Math.floor(( distance % ( 1000 * 60 * 60 )) / ( 1000 * 60 ));
        seconds = Math.floor(( distance % ( 1000 * 60 )) / 1000 );

        // if ( days === 1 ) {
        //   daysText = days + ' day, ';
        // } else {
        //   daysText = days + ' days, ';
        // }

        // if ( hours === 1 ) {
        //   hoursText = hours + ' hour, and ';
        // } else {
        //   hoursText = hours + ' hours, and ';
        // }

        // if ( minutes === 1 ) {
        //   minutesText =  minutes + ' minute';
        // } else {
        //   minutesText =  minutes + ' minutes';
        // }

    

        // Display the result in the element with 
        daysNode.innerText = days;
        hoursNode.innerText = hours;
        minutesNode.innerText = minutes;
        secondsNode.innerText = seconds;
        

        
        //countDownNode.innerText = 'This sale ends in ' + days + hoursText + minutesText;

        // If the count down is finished, write some text
        if ( distance < 0 ) {
          clearInterval( x );
          countDownNode.style.display = 'none';
        }
      }, 1000 );

    }
  };


  setUpVipSale = function() {

    var
      pw = vipSale.config.activePw,
      vipSaleEnabled = vipSale.config.saleIsEnabled,
      vipBarEnabled = vipSale.config.barIsEnabled,
      storedPw;
    
    //console.log( pw );
    //console.log( false );

    if ( !vipSaleEnabled ) {
      localStorage.removeItem( 'vip_pw' );
    }

    if ( localStorage.getItem( 'vip_pw' ) != null ) {
      storedPw = localStorage.getItem( 'vip_pw' );
    }

    



    if ( storedPw === pw ) {

      

      if ( vipBarEnabled ) {
        $( '.announcement-bar' ).removeClass( 'announcement-bar--visible' );
        $( '.vip-announcement-bar' ).addClass( 'vip-announcement-bar--visible' );
      } else {
        $( '.announcement-bar' ).addClass( 'announcement-bar--visible' );
        $( '.vip-announcement-bar' ).removeClass( 'vip-announcement-bar--visible' );
      }


      $( '.template-product .gigi-vip-page-no-access-wrap-2' ).removeClass( 'gigi-vip-page-no-access-wrap-2--visible' );

      $( '.gigi-product-page--vip' ).addClass( 'gigi-product-page--vip-visible' );

     


      
      $( '.gigi-vip-collection-page-wrap' ).css({ 'visibility': 'visible'}).css({ 'height': 'auto'});

      //setUpVipCountdown();

    } else {

      if ( vipBarEnabled ) {
        $( '.announcement-bar' ).addClass( 'announcement-bar--visible' );
        $( '.vip-announcement-bar' ).removeClass( 'vip-announcement-bar--visible' );
      } else {
        $( '.announcement-bar' ).addClass( 'announcement-bar--visible' );
        $( '.vip-announcement-bar' ).removeClass( 'vip-announcement-bar--visible' );
      }

     

      $( '.template-product .gigi-vip-page-no-access-wrap-2' ).addClass( 'gigi-vip-page-no-access-wrap-2--visible' );

      $( '.gigi-vip-page-no-access-wrap' ).show();

      $( '.gigi-vip-page-no-access__password-input' ).on( 'keypress click', function( event ){
        
         
        if ( event.which === 13) {
          //console.log( 'enter pressed' );
          var pwInput = $( '.gigi-vip-page-no-access__password-input' ).val();
          if ( pwInput.toLowerCase() === pw.toLowerCase() ) {
            $( '.gigi-vip-page-no-access__password-error' ).hide();
            //console.log( pwInput.toLowerCase() + ' == ' + pw.toLowerCase() );
            $( '.gigi-vip-page-no-access-wrap' ).hide();
            $( '.gigi-vip-collection-page-wrap' ).css({ 'visibility': 'visible'}).css({ 'height': 'auto'});
            localStorage.setItem( 'vip_pw', pwInput.toLowerCase() );
            

            if ( vipBarEnabled ) {
              $( '.announcement-bar' ).removeClass( 'announcement-bar--visible' );
              $( '.vip-announcement-bar' ).addClass( 'vip-announcement-bar--visible' );
            } else {
              $( '.announcement-bar' ).addClass( 'announcement-bar--visible' );
              $( '.vip-announcement-bar' ).removeClass( 'vip-announcement-bar--visible' );
            }

          } else {

            $( '.gigi-vip-page-no-access__password-error' ).show();
          }
        } 

        if ( event.type === 'click') {
          $( '.gigi-vip-page-no-access__password-error' ).hide();
        }
 
      });

      $( '.gigi-vip-page-no-access__password-submit-btn' ).on( 'click keypress', function( event ){
        //console.log( 'clicked or pressed enter' );
        if (event.which === 13 || event.type === 'click') {
          var pwInput = $( '.gigi-vip-page-no-access__password-input' ).val(); 
          if ( pwInput.toLowerCase() === pw.toLowerCase() ) {
            $( '.gigi-vip-page-no-access__password-error' ).hide();
            //console.log( pwInput.toLowerCase() + ' == ' + pw.toLowerCase() );
            $( '.gigi-vip-page-no-access-wrap' ).hide();
            $( '.gigi-vip-collection-page-wrap' ).css({ 'visibility': 'visible'}).css({ 'height': 'auto'});
            localStorage.setItem( 'vip_pw', pwInput.toLowerCase() );

            if ( vipBarEnabled ) {
              $( '.announcement-bar' ).removeClass( 'announcement-bar--visible' );
              $( '.vip-announcement-bar' ).addClass( 'vip-announcement-bar--visible' );
            } else {
              $( '.announcement-bar' ).addClass( 'announcement-bar--visible' );
              $( '.vip-announcement-bar' ).removeClass( 'vip-announcement-bar--visible' );
            }

          } else {
            
            $( '.gigi-vip-page-no-access__password-error' ).show();
          }
        }
      });

    }



  };


  setupMenu = function() {
    // if the dropdown has a submenu without children, display as one column
    $( '.site-nav__childlist-item' ).each( function(){
      if( $( 'ul', this ).length < 1 ) {
        $( this ).addClass( 'site-nav__childlist-item--one-column' ).closest( '.site-nav__childlist-grid' ).addClass( 'site-nav__childlist-grid---one-column' );
      }
    });

    // offset the submenu to be vertically aligned with the dropdown trigger
    $( '.site-nav--has-dropdown' ).each( function() {
      var distance = $( this ).offset();
      var distanceToLeft = Math.round( distance.left - 16 );
      $( '.site-nav__childlist', this ).css( { 'margin-left' : distanceToLeft + 'px' })
    });

  };

  setUpAnnouncementBarStatusHandler = function() {

    let
      itemStatusStored = JSON.parse( localStorage.getItem( 'gigi-announcement-bar' )),
      itemTimestampString = itemStatusStored ? itemStatusStored.timestamp : '0',
      nowString = Date.now().toString(),
      timePassedSinceStored = parseInt( nowString, 10 ) - parseInt( itemTimestampString, 10 ),
      timeThreshold = 21600000; // 21600000 = 1000*60*60*6 = 6 hours

    
    // if the time that has passed since the announcent bar was hidden is greater than the set threshold
    if ( timePassedSinceStored >= timeThreshold ) {

      // if announcement bar is turned on
      if ( $( '.gigi-site-header-wrap' ).hasClass( 'gigi-site-header-wrap--has-announcement-bar' ) ) {

        // show announcement bar
        $( 'body' ).addClass( 'announcement-bar-is-visible');

      }

    }

    $( '.announcement-bar__button-close' ).on( 'click', function() {
      
      let itemStatusToStore = { value: 'hidden', timestamp: Date.now() };
      localStorage.setItem( 'gigi-announcement-bar', JSON.stringify( itemStatusToStore ) );
      
      // hide announcemt bar
      $( 'body' ).removeClass( 'announcement-bar-is-visible');
      
      // trigger resize to top-align body, search, quickcart, etc to missing announcement bar
      setTimeout( function(){
        $( window ).resize();
      }, 100 );

    });

  };

  setUpEventHandlers = function() {
    $( window ).on( 'resize', onResize ).resize();
    $( window ).on( 'scroll', throttle(onScroll, 500) );

    $( '[data-js="product-inquiry-link"]' ).on( 'click', onProductInquiryClick );

    // menu open/close hover functionality on desktop
    $( '.gigi-site-header__main-nav-wrap .site-nav--has-dropdown' ).on( 'mouseenter', onDropdownMenuItemHover );
    $( '.gigi-site-header__main-nav-wrap .site-nav--has-dropdown' ).on( 'mouseleave', onDropdownMenuItemUnhover );
    $( '.gigi-site-header__main-nav-wrap .gigi-site-header__menu-item-wrap' ).on( 'mouseleave', onDropdownMenuItemUnhover );

    $( '.site-nav--has-dropdown').on( 'click', onDropdownMenuItemClick );

    //initialize fancybox options
    $('[data-fancybox]').fancybox({
        toolbar  : false,
        smallBtn : true,
        buttons: [
          //"zoom",
          //"share",
          //"slideShow",
          //"fullScreen",
          //"download",
          //"thumbs",
          //"close"
        ]
    });


    $( '.product-single__color-link' ).on( 'click', function( event ) {
            
      // $( '.gigi-product-page__color-loader', event.currentTarget ).addClass( 'gigi-product-page__color-loader--active');
      // $( '.product-single__color-box' ).removeClass( 'product-single__color-box--active' );
      // $( '.product-single__color-box', event.currentTarget ).addClass( 'product-single__color-box--active' );

    });

    $( '.gigi-product-page__description-title' ).on( 'click', function(){
      var index = $( event.currentTarget ).attr( 'data-index' );
      //console.log( index );
      $( '.gigi-product-page__description-title' ).toggleClass( 'gigi-product-page__description-title--active' );
      $( '.gigi-product-page__description-wrap' ).not( '[data-index="'+index+'"]' ).hide();
      $( '.gigi-product-page__description-wrap[data-index="'+index+'"]' ).show();
    });

    $( '.gigi-site-header-search__button-toggle' ).on( 'click', onSearchButtonClick );

    $( '.aa-Input' ).keypress(function(e) {
      //disable Enter key
      if ( e.which == 13 ) {
        return false;
      }
    });

    $( '.gigi-site-header__main-nav-button' ).on( 'click', function(event ){
      if ( $( event.currentTarget ).hasClass( 'gigi-site-header__main-nav-button--open' ) ) {
        $( event.currentTarget ).removeClass( 'gigi-site-header__main-nav-button--open' );
      } else {
        $( event.currentTarget ).addClass( 'gigi-site-header__main-nav-button--open' );
        hideSearch();
      }


    });


    $( '.aa-Input' ).on( 'keydown', function(){
      setTimeout( function() {
        if ( $( '.aa-Panel' ).last().css( 'display' ) === 'block' ) {
          $( 'body' ).css({ 'position': 'fixed' });
        } else if ( $( '.aa-Panel' ).last().css( 'display' ) === 'none' ) {
          $( 'body' ).css({ 'position': 'static' });
        }
      }, 200);
      
    });

    /* show additional fields in footer */
    $( '.site-footer__item--newsletter #mc_embed_signup' ).on( 'click', function(event){
      $( '.site-footer__item--newsletter .gigi-mc-extra-field-groups--collapsed' ).slideDown( 300 );
      
    });

    // newlsetter signup page referral source code capture
    var
      queryString = window.location.search,
      urlParams = new URLSearchParams(queryString),
      gigiReferralSourceCode = urlParams.get('grs');
    if ( gigiReferralSourceCode ) {
      $( '.gigi-form__field--refsource' ).attr( 'value', gigiReferralSourceCode+' (sign-up page)' );
    }

    
  };

  detectBrowserIe11 = function() {

    var
      gigiDocument = document,
      gigiBody = gigiDocument.body,
      gigiStyle = gigiBody.style,
      gigiBrowserVersion = null,
      gigiProperty,
      notSupportedStylesOnIE11 = [ 'webkitAppearance' ];

    // Tests IE11 properties
    for ( var i = 0; i < notSupportedStylesOnIE11.length; i++ ) {
      gigiProperty = notSupportedStylesOnIE11[i];
      if ( gigiStyle[ gigiProperty ] != undefined ) {
        gigiBrowserVersion = 'not ie11';
      }
    }

    if ( gigiBrowserVersion === 'not ie11' ){
      //console.log( 'not ie11');
      return false;
    }
    else {
      //console.log( 'ie11');
      return true;
    }

  };

  showOutdatedBrowserWarning = function() {
    $( document ).ready( function() { 

      var isBrowserIe11 = detectBrowserIe11();
      if ( isBrowserIe11 === true ) {
        alert( 'You are using an outdated browser (Internet Explorer). Some features might not work. To view our website, please use a modern browser such as Google Chrome, Firefox, Safari, or Edge. \nThank you. \nThe Gigi Clozeau Team' );
      }

    });
  };


  init = function() {

    showOutdatedBrowserWarning();



    // functions used:
    if ( $( 'body' ).hasClass( 'template-collection--colors' ) ) {
      setUpColorsVipPage();
    } 

    if ( $( 'body' ).hasClass( 'template-collection--vip' ) ) {
      setUpColorsVipPage();
    }


    setUpVipSale();
    setUpVipCountdown();
    //vipSale.init();



    if ( $( 'body' ).hasClass( 'template-page--boutiques' ) ) {
      setUpBoutiquesPage();
    }


    if ( $( 'body' ).hasClass( 'template-product' ) ) {
      sortColorSwatches();

    }

    // if any of the contact form page templates
    if ( $( 'body' ).hasClass( 'template-page--contact-form-product-inquiry' ) || $( 'body' ).hasClass( 'template-page--contact-form' ) ) {
      //console.log( 'wtf');
      manageContactForms();
    }
    
    setUpAnnouncementBarStatusHandler();
    setupMenu();
    setUpEventHandlers();
    modifyExternalLinksTarget();
    initSlideShow();
    injectCssIntoMcIframe();



    if ( stateMap.deviceType === 'mobile' ) {
    }

    if ( stateMap.deviceType === 'desktop' ) {
    }

    

  };

  // Expose the init function.
  return {
    init: init,
    vipSaleHideFromAlgoliaSearchResults: vipSale.hideFromAlgoliaSearchResults
  };

}( jQuery ) );

jQuery( window ).on( 'load', gigiMain.init );
